module.exports = __webpack_public_path__ + "static/media/screenshot-mountains.c6bfbb49.png";